import { EventEmitter } from '@angular/core';
var AppCreditorDetailsComponent = (function () {
    function AppCreditorDetailsComponent() {
        /**
         * The Event emitter used to keep track of any changes to the number of
         * creditors that should be in the formData array.
         * @type {EventEmitter<number>}
         */
        this.updateCreditorCount = new EventEmitter();
    }
    /**
     * The add creditor function fires the event emitter to increase the
     * current number of creditors by one.
     */
    AppCreditorDetailsComponent.prototype.addCreditor = function () {
        this.updateCreditorCount.emit(this.formData.creditors.length + 1);
    };
    AppCreditorDetailsComponent.prototype.checkValue = function (value) {
        return Number(value) > 0;
    };
    return AppCreditorDetailsComponent;
}());
export { AppCreditorDetailsComponent };



// WEBPACK FOOTER //
// /home/runner/work/debtpanel-portal/debtpanel-portal/webforms/legal-aid/src/app/creditor-details/app-creditor-details.component.ts.pre-build-optimizer.js